import { useEffect, useState } from "react";
import { getAllForms } from "../../services/formService";
import "./SaleCount.css";

const SaleCount = () => {
  const [totalSales, setTotalSales] = useState(0);
  const [todaySales, setTodaySales] = useState(0);
  const [weeklySales, setWeeklySales] = useState(0);
  const [monthlySales, setMonthlySales] = useState(0);
  const [nextMonthsSales, setNextMonthsSales] = useState(0);

  useEffect(() => {
    fetchSalesData();
  }, []);

  const fetchSalesData = async () => {
    try {
      const data = await getAllForms();
      const forms = data?.forms || [];

      const now = new Date();
      const startOfToday = new Date(now);
      startOfToday.setHours(0, 0, 0, 0);

      const startOfWeek = new Date(now);
      startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());

      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const startOfNextMonth = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        1
      );

      let total = 0,
        todayCount = 0,
        weeklyCount = 0,
        monthlyCount = 0,
        nextMonthsCount = 0;

      forms.forEach((form) => {
        const formDate = new Date(form.startDate);

        total += form.totalPrice;

        if (
          formDate >= startOfToday &&
          formDate < new Date(startOfToday.getTime() + 86400000)
        ) {
          todayCount += form.totalPrice;
        }
        if (
          formDate >= startOfWeek &&
          formDate < new Date(startOfWeek.getTime() + 7 * 86400000)
        ) {
          weeklyCount += form.totalPrice;
        }
        if (formDate >= startOfMonth && formDate < startOfNextMonth) {
          monthlyCount += form.totalPrice;
        }
        if (formDate >= startOfNextMonth) {
          nextMonthsCount += form.totalPrice;
        }
      });

      setTotalSales(total);
      setTodaySales(todayCount);
      setWeeklySales(weeklyCount);
      setMonthlySales(monthlyCount);
      setNextMonthsSales(nextMonthsCount);
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };

  return (
    <div className="sale-count-container">
      <h2 className="sale-title">
        Total Sales: ₱{totalSales.toLocaleString()}
      </h2>
      <div className="sale-details">
        <p className="sale-item today">
          Today: <span>₱{todaySales.toLocaleString()}</span>
        </p>
        <p className="sale-item week">
          This Week: <span>₱{weeklySales.toLocaleString()}</span>
        </p>
        <p className="sale-item month">
          This Month: <span>₱{monthlySales.toLocaleString()}</span>
        </p>
        <p className="sale-item next-month">
          Next Months: <span>₱{nextMonthsSales.toLocaleString()}</span>
        </p>
      </div>
    </div>
  );
};

export default SaleCount;
